import { useEffect } from "react";

export const useScrollLock = (lock: boolean) => {
  useEffect(() => {
    const mainElement = document.querySelector("main") as HTMLElement | null;

    if (lock) {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);

      document.body.classList.add("player-active");
      if (mainElement) {
        mainElement.classList.add("player-active");
        mainElement.style.overflow = "hidden";
      }

      document.body.style.overflow = "hidden";
    } else {
      document.body.classList.remove("player-active");
      if (mainElement) {
        mainElement.classList.remove("player-active");
        mainElement.style.overflow = "";
      }
      document.body.style.overflow = "";
    }

    return () => {
      document.body.classList.remove("player-active");
      if (mainElement) {
        mainElement.classList.remove("player-active");
        mainElement.style.overflow = "";
      }
      document.body.style.overflow = "";
    };
  }, [lock]);
};
